<script lang="ts" setup>
defineProps<{ text: string }>()
</script>

<template>
  <p class="CommentText" v-html="sanitizeHTML(text)" />
</template>

<style>
.CommentText {
  @apply prose prose-sm;
}
.CommentText .Mention {
  @apply px-1 py-0.5 text-primary-500 bg-primary-50/75 box-decoration-clone rounded;
}
</style>
